import { DATE_FORMAT, EMPTY_VALUE_INDICATOR, useDateService } from 'framework/utils';
import { useShowContext } from 'framework/show';
import { Typography } from '@mui/material';
import { CLIENT_PORTAL_TASK_STATUSES } from 'domain/shared/clientPortal';
import moment from 'moment';
import { Tooltip } from 'framework/ui/mui-builder';

const DeadlineDateField = () => {
  const { data } = useShowContext();
  const { formatDate, getToday } = useDateService();

  const deadlineDate = data?.getValueBySource('dueDate');
  const status = data?.getValueBySource('status');

  if (!deadlineDate || status !== CLIENT_PORTAL_TASK_STATUSES.OPEN) {
    return <Typography>{EMPTY_VALUE_INDICATOR}</Typography>;
  }

  return (
    <Tooltip title={'Due date'} placement={'left'}>
      <Typography color={moment(deadlineDate).isBefore(getToday(), 'day') ? 'error.dark' : 'text'}>
        {formatDate(deadlineDate, DATE_FORMAT.FULL_DATE)}
      </Typography>
    </Tooltip>
  );
};
export default DeadlineDateField;
